import { createSlice } from "@reduxjs/toolkit";
import { fixedAssetRegisterReducer } from "./reducer";
import { initialState } from ".";
import {
  addNewFixedAsset,
  deleteFixedAssetRegisterAction,
  getFixedAssetHistoryAction,
  fixedAssetBulkUploadDataAction,
  getFixedAssetId,
  getFixedAssetRegisterListing,
  getSingleFixedAsset,
  postFixedAssetVerificationAction,
  updateFixedAsset,
  getAuditSessionAction,
  createAuditSessionAction,
  updateAuditSessionAction,
  getFARUsersHistoryAction,
} from "./actions";
import { FixedAssetRegisterTypes } from "./fixedAssetRegisterTypes";

export const fixedAssetRegisterSlice = createSlice({
  name: "fixedAssetRegister",
  initialState,
  reducers: fixedAssetRegisterReducer,
  extraReducers: {
    [getFixedAssetId.pending.toString()]: (state: FixedAssetRegisterTypes) => ({
      ...state,
      fetching: true,
    }),
    [getFixedAssetId.fulfilled.toString()]: (
      state: FixedAssetRegisterTypes,
      { payload }
    ) => {
      const { success, message, result, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        finacAssetId: result,
      };
    },
    [getFixedAssetId.rejected.toString()]: (
      state: FixedAssetRegisterTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    [addNewFixedAsset.pending.toString()]: (
      state: FixedAssetRegisterTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [addNewFixedAsset.fulfilled.toString()]: (
      state: FixedAssetRegisterTypes,
      { payload }
    ) => {
      const { success, message, result = {}, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          result,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
        message,
      };
    },
    [addNewFixedAsset.rejected.toString()]: (
      state: FixedAssetRegisterTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    [getFixedAssetRegisterListing.pending.toString()]: (
      state: FixedAssetRegisterTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [getFixedAssetRegisterListing.fulfilled.toString()]: (
      state: FixedAssetRegisterTypes,
      { payload }
    ) => {
      const { success, message, result = {}, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          result,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
        // message,
        finacAssetListing: result?.data,
        totalCount: result?.total_count,
      };
    },
    [getFixedAssetRegisterListing.rejected.toString()]: (
      state: FixedAssetRegisterTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [getSingleFixedAsset.pending.toString()]: (
      state: FixedAssetRegisterTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [getSingleFixedAsset.fulfilled.toString()]: (
      state: FixedAssetRegisterTypes,
      { payload }
    ) => {
      const { success, message, result = {}, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          result,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
        // message,
        singleFixedAsset: result,
      };
    },
    [getSingleFixedAsset.rejected.toString()]: (
      state: FixedAssetRegisterTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [updateFixedAsset.pending.toString()]: (
      state: FixedAssetRegisterTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [updateFixedAsset.fulfilled.toString()]: (
      state: FixedAssetRegisterTypes,
      { payload }
    ) => {
      const { success, message, result = {}, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          result,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
        message,
      };
    },
    [updateFixedAsset.rejected.toString()]: (
      state: FixedAssetRegisterTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [deleteFixedAssetRegisterAction.pending.toString()]: (
      state: FixedAssetRegisterTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [deleteFixedAssetRegisterAction.fulfilled.toString()]: (
      state: FixedAssetRegisterTypes,
      { payload }
    ) => {
      const { success, message, result = {}, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          result,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
        message,
      };
    },
    [deleteFixedAssetRegisterAction.rejected.toString()]: (
      state: FixedAssetRegisterTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),

    [fixedAssetBulkUploadDataAction.pending.toString()]: (
      state: FixedAssetRegisterTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [postFixedAssetVerificationAction.pending.toString()]: (
      state: FixedAssetRegisterTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [postFixedAssetVerificationAction.fulfilled.toString()]: (
      state: FixedAssetRegisterTypes,
      { payload }
    ) => {
      const { success, message, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
        message,
      };
    },

    [postFixedAssetVerificationAction.rejected.toString()]: (
      state: FixedAssetRegisterTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [fixedAssetBulkUploadDataAction.fulfilled.toString()]: (
      state: FixedAssetRegisterTypes,
      { payload }
    ) => {
      const { success, message, data = {}, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,

        bulkUploadData: payload,
      };
    },

    [fixedAssetBulkUploadDataAction.rejected.toString()]: (
      state: FixedAssetRegisterTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [getFixedAssetHistoryAction.pending.toString()]: (
      state: FixedAssetRegisterTypes
    ) => ({
      ...state,
      fixedAssetHistorFetching: true,
    }),
    [getFixedAssetHistoryAction.fulfilled.toString()]: (
      state: FixedAssetRegisterTypes,
      { payload }
    ) => {
      const { success, message, status_code,result } = payload;

      if (success === 0) {
        return {
          ...state,
          fixedAssetHistorFetching: false,
          error: message,
          fixedAssetHistorySuccess:success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fixedAssetHistorFetching: false,
        fixedAssetHistorySuccess:success,
        statusCode: status_code,
        fixedAssetHistoryData:result?.data,
        message,
      };
    },
    [getFixedAssetHistoryAction.rejected.toString()]: (
      state: FixedAssetRegisterTypes,
      { error }
    ) => ({
      ...state,
      fixedAssetHistorFetching: false,
      fixedAssetHistorySuccess: 0,
      error: error?.message,
    }),

    [getAuditSessionAction.pending.toString()]: (
      state: FixedAssetRegisterTypes,
    ) => ({
      ...state,
      fetching: true
    }),
    [getAuditSessionAction.fulfilled.toString()]: (
      state: FixedAssetRegisterTypes,
      { payload }
    ) => {
      const { status_code, result, message, success } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code
        }
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        auditSessionListing: result,
      }
    },
    [getAuditSessionAction.rejected.toString()]: (
      state: FixedAssetRegisterTypes,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,

    }), 
    [createAuditSessionAction.pending.toString()]: (state: FixedAssetRegisterTypes) => ({
      ...state,
      fetching: true,
    }),
    [createAuditSessionAction.fulfilled.toString()]: (
      state: FixedAssetRegisterTypes,
      { payload }
    ) => {
      const { success, message, status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          success,
          error: message,
          statusCode: status_code,
        };
      }

      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,

      };
    },
    [createAuditSessionAction.rejected.toString()]: (
      state: FixedAssetRegisterTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [updateAuditSessionAction.pending.toString()]: (
      state: FixedAssetRegisterTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [updateAuditSessionAction.fulfilled.toString()]: (
      state: FixedAssetRegisterTypes,
      { payload }
    ) => {
      const { success, message,  status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
        message,
      };
    },
    [updateAuditSessionAction.rejected.toString()]: (
      state: FixedAssetRegisterTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error?.message,
    }),
    [getFARUsersHistoryAction.pending.toString()]: (
      state: FixedAssetRegisterTypes
    ) => ({
      ...state,
      assetHistoryFetching: true,
    }),
    [getFARUsersHistoryAction.fulfilled.toString()]: (
      state: FixedAssetRegisterTypes,
      { payload }
    ) => {
      const {result, success, message,  status_code } = payload;

      if (success === 0) {
        return {
          ...state,
          assetHistoryFetching: false,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        assetHistoryFetching: false,
        success,
        statusCode: status_code,
        fixedAssetUsersHistoryData:result,
        message,
      };
    },
    [getFARUsersHistoryAction.rejected.toString()]: (
      state: FixedAssetRegisterTypes,
      { error }
    ) => ({
      ...state,
      assetHistoryFetching: false,
      success: 0,
      error: error?.message,
    }),
  },
});

export const {
  resetFixedAssetRegisterError,
  resetFixedAssetRegisterSuccess,
  resetFixedAssetRegisterFetching,
  resetFinacAssetId,
  resetFixedAssetRegisterListing,
  resetFixedAssetRegisterMessage,
  resetSingleFixedAsset,
  resetFixedAssetRegisterTotalCount,
  resetFixedAssetRegisterStatusCode,
  resetFixedAssetHistoryData,
  resetFixedAssetHistorySuccess,
  resetBulkUpload,
  resetFixedAssetUsersHistoryData
} = fixedAssetRegisterSlice.actions;
